module.exports = __webpack_public_path__ + "static/img/bg2.84a7976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/bg2.png
// module id = kZ7E
// module chunks = 69